var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordHideIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m2 2 20 20M6.71 6.72A16.23 16.23 0 0 0 2 12s3.64 7 10 7c2.05 0 3.82-.73 5.27-1.71M11 5.06A8.6 8.6 0 0 1 12 5c6.36 0 10 7 10 7s-.7 1.33-2 2.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14 14.24a3 3 0 0 1-4.13-4.35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHideIcon);
export default __webpack_public_path__ + "static/media/password-hide-icon.221d1f351441b4c18bbd4538f340f35f.svg";
export { ForwardRef as ReactComponent };